import { render } from "./VkAppRedirectModal.vue?vue&type=template&id=7bb6d732&scoped=true"
import script from "./VkAppRedirectModal.vue?vue&type=script&lang=js"
export * from "./VkAppRedirectModal.vue?vue&type=script&lang=js"

import "./VkAppRedirectModal.vue?vue&type=style&index=0&id=7bb6d732&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb6d732"]])

export default __exports__